import {
  LOADER_STATUS,
  SET_CURRENT_PAGE,
  SET_PAGE_COUNT,
  SET_PAGE_DATA,
} from "./constants";
const data = [];
export const initialState = {
  loaderStatus: false,
  totalPages: 0,
  pageData: data,
  totalRecords: 0,
  currentPage: 0,
};
const adminAPIReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case SET_PAGE_COUNT:
      return {
        ...state,
        totalPages: action.count,
      };
    case SET_PAGE_DATA:
      return {
        ...state,
        totalRecords: action.data.total_records,
        pageData: action.data.data,
      };
    case SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.currentPage,
      };
    default:
      return state;
  }
};
export default adminAPIReportReducer;
